<template>
	<div class="flex-column">
		<div class="full-height overflow-y-auto pb-50">
			<div>

				<label class="h6 display-block mt-10">
					작업 현장
					<div
						class="input-box size-px-12 font-weight-700 radius-10 mt-10"
						@click="onProject"
					> {{ project_name }}</div>
				</label>

				<label class="h6 display-block mt-20">
					작업명
					<input v-model="item.task_name" class="input-box radius-10 width-100 mt-10" placeholder="작업명을 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-20">
					작업내용
				</label>

				<label class="display-block mt-10 input-box full-width radius-10">
					<v-icon
						class="color-icon"
					>mdi mdi-image</v-icon>
					{{ file_name }}
					<input
						v-show="false"
						type="file"
						placeholder="대표 이미지"
						class="input-box "
						maxlength="250"
						@change="setFile"
						accept="image/*, application/pdf"
					/>
				</label>

				<textarea
					v-model="item.task_content"
					class="input-box radius-10 width-100 mt-10"
					placeholder="작업내용 입력하세요"
					lang="ko">
				</textarea>

				<label class="h6 display-block mt-10">
					작업 위치
					<input v-model="item.task_location" class="input-box radius-10 width-100 mt-10" placeholder="작업위치를 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-20">
					작업 기간

					<div class="justify-space-between gap-10 items-center mt-10">
						<input v-model="item.sDate" class="input-box radius-10  flex-1" placeholder="시작일 입력하세요" maxlength="20" lang="ko" type="date" @click="$event.target.showPicker()"/>
						~
						<input v-model="item.eDate" class="input-box radius-10  flex-1" placeholder="종료일 입력하세요" maxlength="20" lang="ko" type="date" @click="$event.target.showPicker()"/>
					</div>
				</label>

				<label class="h6 display-block mt-20">
					작업 순위
				</label>

				<div
					class="justify-space-between gap-10 mt-10"
				>
					<template
						v-for="(code, c_index) in codes.P006.items"
					>
						<button
							v-if="code.sub_code != '000' && code.is_use == 1 && code.is_view == 1"
							:key="'code_' + c_index"
							class="btn flex-1"
							:class="code.code_index == item.task_priority ? 'btn-' + code.code_color : ''"

							@click="item.task_priority = code.code_index"
						>{{ code.code_name }}</button>
					</template>
				</div>
			</div>
		</div>
		<div
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="postTask"
			>등록</button>
		</div>

		<PopupLayer
			v-if="is_on_project"
		>

			<template
				v-slot:body
			>
				<div class=" bg-white radius-10 flex-column overflow-y-auto">
					<div class="pa-20 bg-popup-title flex-row justify-space-between items-center">
						<h4>작업 현장 조회</h4>
						<v-icon
							@click="is_on_project = false"
						>mdi-close-circle</v-icon>
					</div>

					<hr class="under-line ">

					<div class="pa-10 under-line">
						<div class=" flex-row justify-space-between items-center">

							<input
								v-model="item_search_project.search_value"
								class="input-box-inline flex-1 "
								placeholder="현장명을 입력하세요"
								@keyup.enter="getSearch(1)"
								:rules="$rules.max(item_search_project, 'search_value', 12)"

								lang="ko"
							/>

							<button
								class="btn-primary "

								@click="getSearch(1)"
							>검색</button>
						</div>

						<div class="mt-10 flex-row justify-space-between items-center ">
							<input
								v-model="item_project_new.project_name"
								class="input-box-inline flex-1 "
								placeholder="현장명을 입력하세요"
								@keyup.enter="postProject"
								maxlength="50"
								lang="ko"
							/>

							<button
								class="btn-primary "

								@click="postProject"
							>현장 추가</button>

						</div>
					</div>

					<div class=" pa-10 ">
						<template
							v-if="items_project.length > 0"
						>
							<ul
							>
								<li
									v-for="(project, p_index) in items_project"
									:key="'project_' + p_index"
									class="pa-10 box mb-10 justify-space-between items-center"
									:class="{'bg-gray-light': project.uid == item.project_uid}"
								>
									<div>
										{{ project.project_name }}
									</div>

									<button
										@click="setItem(project)"
										class="btn-primary-outline"
									>선택</button>
								</li>
							</ul>
							<Pagination
								:program="program"
								:options="item_search_project"

								@click="getSearch"
							></Pagination>
						</template>
						<Empty
							v-else
							text="선물 대상을 조회하세요"
						></Empty>
					</div>
				</div>
			</template>
		</PopupLayer>
	</div>
</template>

<script>

import PopupLayer from "../Layout/PopupLayer";
import Pagination from "../../components/Pagination";
export default {
	name: 'ProjectTask'
	,
	components: {Pagination, PopupLayer},
	props: ['user', 'codes']
	, data: function(){
		return {
			program: {
				name: '새 작업 등록'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
			}
			, item: {
				work_uid: this.$route.params.idx
				, task_priority: '1'
				, project_uid: this.$route.params.idx
			}
			, items_project: []
			, item_search_project: {
				page: 1
				, list_cnt: 10
				, search_type: 'project_name'
				, search_value: ''
			}
			, is_on_project: false
			, item_project: {
				project_name: ''
			}
			, item_project_new: {
				project_name: ''
			}
		}
	}
	, computed: {
		file_name: function(){
			let t = '첨부파일을 선택하세요'

			if(this.item.b_file){
				t = this.item.b_file.name
			}

			return t
		}
		, project_name: function(){
			let t = '작업 현장을 선택하세요'
			if(this.item_project?.project_name){
				t = this.item_project.project_name
			}
			return t
		}
	}
	, methods: {
		postTask: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/postTask'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
					this.$bus.$emit('to', { name: 'ProjectTaskDetail', params: {idx: result.data }})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, getProjectList: async function(){
			
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'project/getProjectList'
					, data: this.item_search_project
				})

				if(result.success){
					this.items_project = result.data.result
					this.$set(this.item_search_project, 'total_count', result.data.tCnt)

					if(this.item.project_uid){
						for(let i = 0; i < this.items_project.length; i++){
							if(this.items_project[0].uid == this.item.project_uid){
								this.item_project = this.items_project[0]
							}
						}
						console.log('item_project', this.item_project, this.item.project_uid)
					}
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, onProject: function(){
			this.is_on_project = true
		}
		, setItem: function(project){
			this.item.project_uid = project.uid
			this.item_project = project
			this.is_on_project = false
		}
		, postProject: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/postProject'
					, data: this.item_project_new
				})

				if(result.success){

					this.$set(this.item_project, 'uid', result.data)
					this.$set(this.item, 'project_uid', result.data)
					this.$set(this.item_project, 'project_name', this.item_project_new.project_name)

					this.item_project_new = {
						project_name: ''
					}

					this.is_on_project = false
					await this.getSearch(1)
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		,setFile: function(e){
			let file = e.target.files[0]
			this.$set(this.item, 'b_file', file)
		}
		, getSearch: function(page){
			this.item_search_project.page = page
			this.getProjectList()
		}
	}
	, created() {
		console.log('task')
		this.$bus.$emit('onLoad', this.program)
		this.getProjectList()
	}
}
</script>